import ReactGA from "react-ga4";
import { GA_KEY } from "../redux/Url";

const MEASUREMENT_ID = GA_KEY;

export const initGA = (partner_id) => {
  //ReactGA.initialize(MEASUREMENT_ID);
  ReactGA.initialize([
    {
        trackingId: MEASUREMENT_ID, // Replace with your GA4 ID
        gaOptions: {
          user_id: partner_id, // Optional during init
        },
    },
]);
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (action, partner_id, lead_id, params) => {
  ReactGA.event(action, {
      ...params,
      user_id: partner_id,
      lead_id: lead_id
  });
};
